/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicAssetImportResultDto } from './PublicAssetImportResultDto';

/**
 * Detailed import result
 */
export type PublicExternalCatalogImportResultDto = {
    /**
     * Status of the import
     */
    importStatus?: PublicExternalCatalogImportResultDto.importStatus;
    /**
     * Per-asset import status
     */
    results?: Array<PublicAssetImportResultDto>;
};

export namespace PublicExternalCatalogImportResultDto {

    /**
     * Status of the import
     */
    export enum importStatus {
        SUCCESS = 'SUCCESS',
        PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
        FAILURE = 'FAILURE',
    }


}
